import { EditDesc } from '90.quickConnect.Models/models';

const mapReadOnlyDesc = ({ value }: EditDesc): EditDesc =>
  ({
    value: value ?? '',
  } as unknown as EditDesc);

export default mapReadOnlyDesc;
